import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import ListOfFundsItem from './ListOfFundsItem';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import FundDetails from './FundDetails';
import { loadListOfFunds } from '../../store/actions/libraryOfFunds';

const itemPerPage = 8;

export interface IListOfFundsProps{
    createPortfolio?: boolean;
}

const ListOfFunds: React.FC<IListOfFundsProps> = ({ createPortfolio }) =>{

    const funds = useAppSelector(state => state.libraryOfFundsReducer.funds);
    const page = useAppSelector(state => state.libraryOfFundsReducer.page);
    const dispatch = useAppDispatch();


    useEffect(() => {
        if (funds === undefined) {
            dispatch(loadListOfFunds());
        }
    }, [funds, dispatch]);

    if (funds === undefined){
        return <></>;
    }

    const fundCount = funds.length;
    const lineArray = Array(Math.floor((fundCount)/2)).fill(undefined);

    return <Box display={"flex"} flexDirection={createPortfolio ? "column" : 'row'} justifyContent={"start"} width={"100%"} padding={"23px 0"} gap={"39px 40px"} flexWrap={createPortfolio ? undefined : "wrap"} className={"listOfFunds"} sx={createPortfolio ? { overflowY: "scroll", scrollBehavior: 'smooth', scrollSnapType: "y mandatory", height: "620px", paddingBottom: "50px", scrollbarGutter: "stable"} : undefined}>
        {createPortfolio ? <>
            {lineArray.map((a, i) => (<Box display={"flex"} gap={"40px"} key={`fund-line-${i}`} sx={{scrollSnapAlign: "center none", paddingTop:"20px"}}>
                <ListOfFundsItem fund={funds[i*2]} createPortfolio expand={true} />
                {(i*2+1) < funds.length && <ListOfFundsItem fund={funds[i*2+1]} createPortfolio expand={true} />}
            </Box>))}
            <FundDetails pageRange={funds.map(f => f.id)} createPortfolio showPopin/>
        </> : <>
        {funds.slice(itemPerPage * page, itemPerPage * (page + 1) - itemPerPage/2).map(f => (<ListOfFundsItem fund={f} key={`fund-${f.id}`} />))}
        <FundDetails pageRange={funds.slice(itemPerPage * page, itemPerPage * (page + 1) - itemPerPage/2).map(f => f.id)} />
        {funds.slice(itemPerPage * page + itemPerPage/2, itemPerPage * (page + 1)).map(f => (<ListOfFundsItem fund={f} key={`fund-${f.id}`} />))}
        <FundDetails pageRange={funds.slice(itemPerPage * page + itemPerPage/2, itemPerPage * (page + 1)).map(f => f.id)} />
        </>}
    </Box>;
}

export default ListOfFunds;